module.exports = __webpack_public_path__ + "static/media/Logout.b1572e00.svg";